

import ClockIcon from './Icons/ClockIcon.vue'

export default {
    components: { ClockIcon },
    props: {
        counterText: {
            required: true
        },
        date: {
            required: true
        },
        showIcon: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            formattedDate: ''
        }
    },
    computed: {
        isUnavailable () {
            return this.date === null
        }
    },
    mounted () {
        this.setLabels(this.date)
    },
    methods: {
        setLabels (date) {
            if (!date) {
                this.formattedDate = this.$t('counter.dateText', { date: '1800/01/01' })
                return
            }
            this.formattedDate = this.$t('counter.dateText', {
                date: new Date(date)
                    .toLocaleDateString('en-CA')
                    .replace(/-/g, '/')
            })
        }
    }
}
